import { createEffect, createEvent, createStore } from "effector"
import { API } from "../API"
import { IStorie } from "../types/stories";

export const getStories = createEffect(async()=>{
    const res = await API.getStories();

    return res.stories;
})

export const $stories = createStore<IStorie[]>([])
.on(getStories.doneData,(_, res)=> res)

export const setDeeplinkStoryId = createEvent<string | null>();
export const $deeplinkStoryId = createStore<string | null>(null)
.on(setDeeplinkStoryId, (_, id) => id)